import React from 'react';

const ThreeDots = ({ className = '', stroke = '#737373' }) => {
  return (
    <svg width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M2 2.25C1.80109 2.25 1.61032 2.17098 1.46967 2.03033C1.32902 1.88968 1.25 1.69891 1.25 1.5C1.25 1.30109 1.32902 1.11032 1.46967 0.96967C1.61032 0.829018 1.80109 0.75 2 0.75C2.19891 0.75 2.38968 0.829018 2.53033 0.96967C2.67098 1.11032 2.75 1.30109 2.75 1.5C2.75 1.69891 2.67098 1.88968 2.53033 2.03033C2.38968 2.17098 2.19891 2.25 2 2.25ZM2 8.25C1.80109 8.25 1.61032 8.17098 1.46967 8.03033C1.32902 7.88968 1.25 7.69891 1.25 7.5C1.25 7.30109 1.32902 7.11032 1.46967 6.96967C1.61032 6.82902 1.80109 6.75 2 6.75C2.19891 6.75 2.38968 6.82902 2.53033 6.96967C2.67098 7.11032 2.75 7.30109 2.75 7.5C2.75 7.69891 2.67098 7.88968 2.53033 8.03033C2.38968 8.17098 2.19891 8.25 2 8.25ZM2 14.25C1.80109 14.25 1.61032 14.171 1.46967 14.0303C1.32902 13.8897 1.25 13.6989 1.25 13.5C1.25 13.3011 1.32902 13.1103 1.46967 12.9697C1.61032 12.829 1.80109 12.75 2 12.75C2.19891 12.75 2.38968 12.829 2.53033 12.9697C2.67098 13.1103 2.75 13.3011 2.75 13.5C2.75 13.6989 2.67098 13.8897 2.53033 14.0303C2.38968 14.171 2.19891 14.25 2 14.25Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ThreeDots;
